module.exports = __webpack_public_path__ + "img/close_vector.7ff704ec.svg";